import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';

const CookieConsent = () => {
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
  
        });
    };
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-banner">
        <div className="cookie-consent">
            <Container>
                <div className="cookieInner">
                    <p>Our website uses cookies to enhance your browsing experience. By using our website, you agree to the use of cookies as per our Privacy Policy | Cookie Policy.
                    </p>
                    <div className="btnAction">
                        <button onClick={acceptCookies}>Accept and Close</button>
                        <button className='decline' onClick={declineCookies}>Decline</button>
                    </div>
                </div>
        </Container>
        </div>
    </div>
  );
};

export default CookieConsent;
